import { EventLoader, eventLoader } from "@otto-ec/global-event-loader";
import { o_global } from "../namespaces";

o_global.EventLoader ||= EventLoader;
o_global.eventLoader ||= eventLoader();
o_global.onloadHandler ||=
  /**
 *
 *
 */
  (cb: EventListener): void => o_global.eventLoader.onLoad(100, cb);
